import { render, staticRenderFns } from "./DealDocumentsTab.vue?vue&type=template&id=323f730e"
import script from "./DealDocumentsTab.vue?vue&type=script&lang=js"
export * from "./DealDocumentsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports